import styles from './NewsletterHero.module.css'
import PostSocials from 'shared-components/ui/PostSocials'
import clsx from 'clsx'
import { BasicStyledComponent, DSImage, DSSocialIcon } from 'shared-definitions/types'
import AppImage from 'shared-components/ui/AppImage'
import { ThemeContext } from 'shared-components/contexts/ThemeContext'

interface PostProps {
  image: DSImage
  socials?: readonly DSSocialIcon[]
  title: string
  date: string
}

interface NewsletterHeroProps extends BasicStyledComponent {
  post: PostProps
  absoluteLink: string | null
}

const NewsletterHero: React.VFC<NewsletterHeroProps> = ({ absoluteLink, className, post }) => {
  const { theme } = ThemeContext.useContainer()
  return (
    <div className={clsx(styles.container, className)}>
      {post.image ? (
        <AppImage
          imageClassName={styles.image}
          className={clsx(styles.imageContainer, { [styles.imageInverted]: theme === 'dark' })}
          layout="raw"
          image={post.image}
          sizes={228}
        />
      ) : null}
      <div className={styles.postedInfo}>
        {absoluteLink ? (
          <PostSocials
            className={styles.socials}
            title={post.title}
            socials={post.socials ?? []}
            absoluteLink={absoluteLink}
          />
        ) : null}
        <div className={styles.date}>{post.date}</div>
      </div>
    </div>
  )
}

export default NewsletterHero
